const versionConfig = {
    version: 'v0.1.1'
}

export default versionConfig